import styled from 'styled-components';
import MuiTable from '@mui/material/Table';

export const Table = styled(MuiTable)`
  &.MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
  }
`;
